import { useEffect, useSyncExternalStore } from "react";
import { useQuery } from "@tanstack/react-query";
import {
    getPlatformUnavailableReason,
    isPlatformReachable,
    subscribePlatformUnavailable,
} from "@/lib/platform-unavailable";

export const RECOVERY_POLL_INTERVAL_MS = 30_000;

const queryKeys = {
    recovery: ["platform-recovery"],
} as const;

export const usePlatformUnavailableReason = () =>
    useSyncExternalStore(
        subscribePlatformUnavailable,
        getPlatformUnavailableReason,
    );

// Reloads instead of resuming in place: the platform was most likely redeployed
// in the meantime, so the running bundle may already be stale. The first probe
// only runs after one interval (fresh initialData), which caps a flapping
// backend at one reload per interval instead of a tight reload loop.
export const usePlatformRecovery = () => {
    const { data: isBackendReachable } = useQuery({
        queryKey: queryKeys.recovery,
        queryFn: isPlatformReachable,
        initialData: false,
        staleTime: Infinity,
        refetchInterval: RECOVERY_POLL_INTERVAL_MS,
        refetchIntervalInBackground: true,
    });

    useEffect(() => {
        if (isBackendReachable) {
            window.location.reload();
        }
    }, [isBackendReachable]);
};
